import { render } from "./PricesComponent.vue?vue&type=template&id=f6124fb2&scoped=true"
import script from "./PricesComponent.vue?vue&type=script&lang=js"
export * from "./PricesComponent.vue?vue&type=script&lang=js"

import "./PricesComponent.vue?vue&type=style&index=0&id=f6124fb2&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\svila\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6124fb2"]])

export default __exports__